import React from 'react';

const Arrow = () => (
  <svg
    width="45"
    height="45"
    viewBox="0 0 59 59"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.0162 13.9463L28.0162 42.8317L18.5516 34.2275C18.166 33.8734 17.6616 33.6769 17.1381 33.6769C16.6145 33.6769 16.1101 33.8734 15.7245 34.2275C15.3799 34.5345 15.1709 34.9656 15.1433 35.4263C15.1156 35.887 15.2716 36.3399 15.577 36.6859L15.7245 36.8334L27.0574 47.2567L28.4587 48.5596C28.8532 48.9054 29.3599 49.096 29.8845 49.096C30.4091 49.096 30.9158 48.9054 31.3104 48.5596L32.7116 47.2567L44.0445 36.6859C44.3891 36.3789 44.5981 35.9479 44.6258 35.4872C44.6534 35.0265 44.4975 34.5736 44.192 34.2275L44.0445 34.2275C43.659 33.8734 43.1545 33.6769 42.631 33.6769C42.1075 33.6769 41.603 33.8734 41.2174 34.2275L31.7283 42.9546L31.7283 13.9463C31.7283 13.4573 31.534 12.9883 31.1883 12.6426C30.8425 12.2968 30.3735 12.1025 29.8845 12.1025C29.3955 12.1025 28.9266 12.2968 28.5808 12.6426C28.235 12.9883 28.0408 13.4573 28.0408 13.9463"
      fill="#005E5D"
    />
  </svg>
);

export const ButtonScroll = () => (
  <div
    style={{
      width: '60px',
      height: '60px',
      background: '#FFEA8F',
      boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.08)',
      borderRadius: '3px',
    }}
  >
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        paddingTop: '7.5px',
      }}
    >
      <Arrow />
    </div>
  </div>
);
